import type { MeContext } from '@vizit/api';
import { ACCESS_ROUTES } from '../constants';
import type { LandingDecision } from '../types';
import { resolveLanding } from './resolve-landing';

export function landingDecisionToRoute(decision: LandingDecision): string | null {
  switch (decision.type) {
    case 'workspace':
      return ACCESS_ROUTES.workspaceShell(decision.workspaceSlug);
    case 'portfolioPicker':
      return ACCESS_ROUTES.portfolioGrid;
    case 'workspacePicker':
      return ACCESS_ROUTES.portfolioWorkspaces(decision.portfolioId);
    case 'flatWorkspacePicker':
      return ACCESS_ROUTES.flatWorkspaceGrid;
    case 'noAccess':
      return null;
  }
}

// Highest route the user can reach — never `/` (would loop with landing resolution).
export function resolveFallbackRoute(context: MeContext): string | null {
  return landingDecisionToRoute(resolveLanding(context));
}
